import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

interface ReorderQuestionsParams {
  pickemId: string;
  questionIds: string[];
}

export async function reorderQuestions({ pickemId, questionIds }: ReorderQuestionsParams) {
  const response = await api.put(apiEndpoints.reorderQuestions(pickemId), {
    questionIds,
  });
  return response.data;
}

export function useReorderQuestionsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reorderQuestions,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.questions.all });
      toast.success('Question order updated successfully');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.error || 'Failed to reorder questions');
    },
  });
}
